import { render, staticRenderFns } from "./history-detail.vue?vue&type=template&id=0d51c32f&scoped=true"
import script from "./history-detail.vue?vue&type=script&lang=js"
export * from "./history-detail.vue?vue&type=script&lang=js"
import style0 from "./history-detail.vue?vue&type=style&index=0&id=0d51c32f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d51c32f",
  null
  
)

export default component.exports